const authConfig = {
  authority: 'https://bettertrucks-71arlr.us1.zitadel.cloud',
  client_id: '338984518608318579',
  response_type: 'code',
  scope: 'openid profile email',
  userinfo_endpoint: 'https://bettertrucks-71arlr.us1.zitadel.cloud/oidc/v1/userinfo',
  response_mode: 'query',
  code_challenge_method: 'S256',
};

export default authConfig;
